import { env } from '@/config/env';

/**
 * GiftUtils
 * Composes the full gift-resource URL from a relative path.
 * Mirrors Flutter's per-model `path` getters (Env.giftsBucket + <path>),
 * e.g. GiftInfo.path (gift_info.dart:13), ChatMessage.giftPath,
 * LatestLiveGiftInfo.path (latest_live_gift_info.dart:15) — consolidated
 * into one string-based helper on the web.
 */
export class GiftUtils {
  /** Full URL of a gift resource: `env.GIFTS_BUCKET + resourcePath`. */
  static getGiftPath(resourcePath: string): string {
    return env.GIFTS_BUCKET + resourcePath;
  }
}
